<template>
  <div>
    <!-- Block -->
    <div class="block">
      <!-- top search bar -->
      <div class="pa-5 d-flex">
        <div class="form-input-group flex-grow-1 mr-5">
          <v-icon class="prepend-icon">search</v-icon>
          <input
            type="text"
            class="pl-42px"
            placeholder="搜尋"
            v-model="textFilter"
          />
        </div>
        <SimpleSelectWithSearchInput
          class="mr-5"
          buttonPlaceholder="篩選年份"
          buttonWidth="140px"
          modalWidth="140px"
          modalBodyHeight="208px"
          :options="options.year"
          :selectedValue.sync="yearFilter"
        ></SimpleSelectWithSearchInput>
        <SimpleSelectWithSearchInput
          class="mr-5"
          buttonPlaceholder="篩選月份"
          buttonWidth="140px"
          modalWidth="140px"
          modalBodyHeight="208px"
          :options="options.month"
          :selectedValue.sync="monthFilter"
        ></SimpleSelectWithSearchInput>
        <SimpleSelectWithSearchInput
          class="mr-5"
          buttonPlaceholder="篩選日期"
          buttonWidth="140px"
          modalWidth="140px"
          modalBodyHeight="208px"
          :options="options.date"
          :selectedValue.sync="dateFilter"
        ></SimpleSelectWithSearchInput>
        <button class="btn btn-primary w-88px">搜尋</button>
      </div>

      <!-- table -->
      <div class="table">
        <div class="table-head">
          <!-- column head -->
          <div class="form-item d-flex px-5 h-60px align-center">
            <h5 class="col-account-name">帳號</h5>
            <h5 class="col-change">異動</h5>
            <h5 class="col-url">網址</h5>
            <h5 class="col-create-date">建立日期</h5>
          </div>
        </div>
        <div class="table-body">
          <div
            class="form-item d-flex h-60px align-center"
            v-for="item in filterNumPerPageTableList"
            :key="item.id"
          >
            <div class="h5 col-account-name">{{ item.accountName }}</div>
            <div class="h5 col-change">{{ item.change }}</div>
            <div class="h5 col-url">
              <a
                class="btn square text-decoration-none"
                :href="item.url"
                target="_blank"
              >
                <v-icon>link</v-icon>
              </a>
            </div>
            <div class="h5 col-create-date">{{ item.createDate }}</div>
          </div>
        </div>
      </div>

      <!-- table footer -->
      <div
        class="d-flex justify-end align-center h5"
        style="padding: 26px 20px;"
      >
        <!-- item per page -->
        <div class="mr-10px d-flex align-center">
          <span class="mr-10px">單頁顯示筆數</span>
          <TableNumPerPage
            v-model="numberOfItemsPerPage"
            @input="currentPage = 1"
          ></TableNumPerPage>
        </div>
        <!-- item total -->
        <div class="mr-10px">
          <span style="margin-right: 2px">{{ displayPageToPage() }}</span>
          <span>共 {{ filterTableList.length }}筆</span>
        </div>
        <!-- pre and next -->
        <div>
          <button class="btn square w-32px h-32px mr-4" @click="lastPage">
            <v-icon>navigate_before</v-icon>
          </button>
          <button class="btn square w-32px h-32px" @click="nextPage">
            <v-icon>navigate_next</v-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableNumPerPage from '@/components/TableNumPerPage.vue';
import SimpleSelectWithSearchInput from '@/components/Selection/SimpleSelectWithSearchInput.vue';

export default {
  components: {
    TableNumPerPage,
    SimpleSelectWithSearchInput,
  },
  data: () => ({
    // filter
    textFilter: '',
    yearFilter: '',
    monthFilter: '',
    dateFilter: '',
    // options
    options: {
      year: [...Array(100).keys()].map((i) => `${i + 2001}`),
      month: [...Array(12).keys()].map((i) => `${i + 1}`),
      date: [...Array(31).keys()].map((i) => `${i + 1}`),
    },
    // tablelist
    tableList: [
      {
        id: '1801',
        accountName: 'Account Name1',
        change: '修改 (Category,109)',
        url: 'https://corp.adata.com/tw',
        createDate: '2020.08.08 11:13:09',
      },
      {
        id: '1802',
        accountName: 'Account Name2',
        change: '修改2 (Category,109)',
        url: 'https://corp.adata.com/tw',
        createDate: '2020.08.08 11:13:09',
      },
    ],
    numberOfItemsPerPage: '10', // at bottom table footer
    currentPage: 1,
  }),
  computed: {
    filterTableList() {
      const vm = this;
      return (
        this.tableList
          // textFilter
          .filter((item) =>
            item.accountName.toLowerCase().includes(vm.textFilter),
          )
      );
    },
    filterNumPerPageTableList() {
      const vm = this;
      return this.filterTableList.filter((item, i) => {
        if (vm.numberOfItemsPerPage === 'All') return true;
        return (
          i <= Number(vm.numberOfItemsPerPage) * vm.currentPage - 1 &&
          i >= Number(vm.numberOfItemsPerPage) * (vm.currentPage - 1)
        );
      });
    },
  },
  methods: {
    editItem() {
      this.$router.push({ path: '/edm-send-list/edit' });
    },
    deleteItem(itemId) {
      const index = this.tableList.findIndex((item) => item.id === itemId);
      this.tableList.splice(index, 1);
      console.log(index);
    },
    stampToDate(stamp) {
      const dateObj = new Date(stamp);
      const year = dateObj.getFullYear();
      const month = dateObj.getMonth() + 1;
      const date = dateObj.getDate();

      return `${year}年${month}月${date}日`;
    },
    lastPage() {
      if (this.currentPage === 1) {
        return;
      }
      this.currentPage -= 1;
    },
    nextPage() {
      if (this.numberOfItemsPerPage === 'All') return;
      if (
        this.currentPage * Number(this.numberOfItemsPerPage) >
        this.filterTableList.length
      ) {
        return;
      }
      this.currentPage += 1;
    },
    displayPageToPage() {
      let left;
      let right;

      const filterLength = this.filterTableList.length;
      const perPageLength = Number(this.numberOfItemsPerPage);

      if (this.numberOfItemsPerPage === 'All') {
        left = 1;
        right = filterLength;
      } else {
        left = 1 + perPageLength * (this.currentPage - 1);
        right = perPageLength * this.currentPage;
        if (perPageLength * this.currentPage > filterLength) {
          right = filterLength;
        }
      }

      return `${left}-${right}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  .col-account-name {
    width: 200px;
    margin-right: 20px;
  }
  .col-url {
    width: 40px;
    margin-right: 40px;
    margin-left: auto;
    text-align: center;
  }
  .col-create-date {
    width: 130px;
    text-align: right;
  }
}
</style>
